import { createTheme } from '../theme/create-theme';
import type { Direction, Theme } from '../theme/types';

interface HumandaThemeConfig {
  direction?: Direction;
}

/**
 * Creates a HUMANDA-branded MUI theme with violet primary color.
 *
 * @example
 * ```tsx
 * import { createHumandaTheme } from '@apal/shared-theme';
 *
 * const theme = createHumandaTheme();
 *
 * <ThemeProvider theme={theme}>
 *   <App />
 * </ThemeProvider>
 * ```
 */
export function createHumandaTheme(config: HumandaThemeConfig = {}): Theme {
  return createTheme({
    primaryColor: 'humandaViolet',
    direction: config.direction,
  });
}
